import { render, staticRenderFns } from "./JitsiSecureMeeting.vue?vue&type=template&id=a5b543f4&"
import script from "./JitsiSecureMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiSecureMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b543f4')) {
      api.createRecord('a5b543f4', component.options)
    } else {
      api.reload('a5b543f4', component.options)
    }
    module.hot.accept("./JitsiSecureMeeting.vue?vue&type=template&id=a5b543f4&", function () {
      api.rerender('a5b543f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/JitsiSecureMeeting.vue"
export default component.exports